import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

export class SingleTextInput extends Component {
  renderError() {
    const { errorText } = this.props;

    return (
      <span when="required" className="label label-danger header invalid-label margin-required">
        { errorText }
      </span>
    );
  }

  renderLabel() {
    const {
      id,
      labelText,
      errorText,
      field,
    } = this.props;

    return (
      <label htmlFor={ id }>
        { labelText }
        { field.touched && field.error && errorText ? this.renderError() : null }
      </label>
    );
  }

  render() {
    const {
      id,
      placeholder,
      labelText,
      className,
      formGroup,
      inline,
      size,
      field,
      children,
    } = this.props;

    const divClassNames = classNames({
      'form-group': formGroup,
      'has-error': field.error && field.touched,
      'inline-element': inline,
    });

    const inputAttributes = {
      id,
      type: 'text',
      className: 'form-control form-control-ie'.concat(' ', className),
      value: field.value,
      placeholder,
      onChange: this.props.handleOnChange,
      onBlur: this.props.handleOnBlur,
      'data-qa-item': id,
      size,
    };

    return (
      <div className={ divClassNames }>
        { labelText ? this.renderLabel() : null }
        <input { ...inputAttributes } />
        {children}
      </div>
    );
  }
}

SingleTextInput.propTypes = {
  children: PropTypes.any,
  id: PropTypes.string.isRequired,
  field: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  handleOnChange: PropTypes.func,
  handleOnBlur: PropTypes.func,
  labelText: PropTypes.node,
  errorText: PropTypes.node,
  className: PropTypes.string,
  formGroup: PropTypes.bool,
  inline: PropTypes.bool,
  size: PropTypes.number,
};
